import { useState } from 'react';
import { Form } from 'react-bootstrap';
import { useSelector } from 'react-redux';

const OptionEntry = (props) => {
  let options = useSelector((state) => state.options[props.entry.optionType]);
  if (!props.entry.optionType && props.options) {
    options = props.options;
  }

  let [selectedOption, updateValue] = useState(props.value[props.entry.mapTo] ? props.value[props.entry.mapTo] : { id: null });
  console.log(props.value[props.entry.mapTo]);
  let myChangeHandler = (event) => {
    let val = event.target.value;
    
    for(let opt of options){
       if(opt.id === parseInt(val)) {
        props.value[props.entry.mapTo] = opt;
        updateValue(opt);
        props.onChangeHandler(props.entry.mapTo, opt);
       }

    };
  };

  return (
    <Form.Group>
      <Form.Label>{props.entry.label}</Form.Label>
      <Form.Control
        as="select"
        name={props.entry.mapTo}
        onChange={myChangeHandler}
        defaultValue={ selectedOption?.id }
      >
        <option value={null}></option>
        { options ? options.map((option) => {
          return (
            <option key={`optionKey-${props.entry.mapTo}-${option.id}`}
              value={ option.id }>
              {option.option}
            </option>
          );
        }) : null}
      </Form.Control>
    </Form.Group>
  );
};

export default OptionEntry;
